import { render, staticRenderFns } from "./tabList.vue?vue&type=template&id=0a0b62d6&scoped=true&"
import script from "./tabList.vue?vue&type=script&lang=js&"
export * from "./tabList.vue?vue&type=script&lang=js&"
import style0 from "./tabList.vue?vue&type=style&index=0&id=0a0b62d6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0b62d6",
  null
  
)

export default component.exports